export const buttonVariants = {
  normal: {
    scale: 1,
    rotate: 0,
  },
  animate: {
    scale: [1, 1.5, 1.3, 1.5, 1],
    rotate: [0, -15, 15, -15, 0],
    transition: {
      duration: 0.8,
      times: [0, 0.2, 0.4, 0.6, 1],
      ease: 'easeInOut',
    },
  },
};
